import script from "./list.vue?vue&type=script&lang=ts&setup=true"
export * from "./list.vue?vue&type=script&lang=ts&setup=true"

import "./list.scss?vue&type=style&index=0&id=e3bda096&lang=scss&scoped=true"

import exportComponent from "D:\\Projects\\WebStorm\\operation-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e3bda096"]])

export default __exports__